import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
//import Utils from '../../../custom/utils';
import {API, BROKERID} from "../../../../config";
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import {connect} from "react-redux";
import utils from "../../../../util";
//import AppBar from '@material-ui/core/AppBar';
//import Toolbar from '@material-ui/core/Toolbar';
//import Typography from '@material-ui/core/Typography';

//const outbound = API.service('withdrawal');
const holdings = API.service('holdings');
const certificates = API.service('certificate');

const m = require('moment-timezone');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_popup':{
            display:'block'
        }
    },
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,
        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    },
    formControl:{
      width:'100%'
    }
});

class WalletJournal extends Component {
    state={
      quantity: 0,
      restricted_until:'2021-01-01',
      type:'FREE',
      company_account:'',
      comment:'',
      companies:false,
      holdings:[],
      instrument:'',
      remainder:0,
    };

    complete = () => {
      const app = this;

      let restricted = null;

      if (this.state.type === "REST") {
        restricted = m.utc(this.state.restricted_until);
      }

      let payload =
          {
              _investor_account:this.props.investor._account,
              _quantity: parseInt(this.state.quantity,0),
              _company_account:this.state.instrument,
              _type:this.state.type,
              _restricted_until_date: restricted,
              _comment:'Manual Added '+ this.state.quantity + " Units - " + this.props.user.data.email + ' ' + this.state.comment
          };
        holdings.find({query:{_company_account: this.state.instrument, _investor_account:this.props.investor._account, _type: this.state.type,$limit:1,$sort:{_id:-1}}}).then(h=>{
          if(h.total === 0){
            holdings.create(payload).then(w=>{
              app.props.context.update({
                popupContent: false,
              })
            });
          } else {
            let payload1 = h.data[0];
            payload1._type = 'DEAD';
            holdings.update(payload1._id,payload1);
            payload._quantity = payload._quantity + payload1._quantity;
            holdings.create(payload).then(w=>{
              app.props.context.update({
                popupContent: false,
                holdingsUpdates:true
              })
            });
          }

        })

    };

    componentDidMount() {
      var app = this;
      let t = [];
      certificates.find({query:{broker_id:BROKERID,type:'sum'}}).then(c=>{

        c.forEach(h=>{
          t['a' + h._account.toString()] = h;
        });

        app.setState({
          companies:c
        });

        holdings.find({query:{type:'total_sum'}}).then (h=>{
          h.forEach(x=>{
            if(typeof t['a' + x._company_account.toString()] === 'undefined'){
              t['a' + x._company_account.toString()] = [];
            }
            t['a' + x._company_account.toString()]['allocated'] = x.total;
          });
        })

        app.setState({
          holdings:t
        })
      })
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state, error: '' }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
        if(event.target.name==="instrument"){
          //Calc Remaining
          if(typeof this.state.holdings['a'+ event.target.value.toString()].allocated !== 'undefined'){
            let remainder = this.state.holdings['a'+ event.target.value.toString()]._holdings - this.state.holdings['a'+ event.target.value.toString()].allocated
            this.setState({
              remainder: remainder
            })
          } else {
            let remainder = this.state.holdings['a'+ event.target.value.toString()]._holdings;
            this.setState({
              remainder: remainder
            })
          }
        }
    };

    close = () =>{
        this.props.context.update({
            popupContent: false,
        })
    };

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
              <div style={{padding:10}}>
                <b>Investor:</b> {this.props.investor._firstname} {this.props.investor._surname}<br />
                <b>Account:</b> {this.props.investor._account}<br /><br />
                <br/>

                <FormControl className={classes.formControl} style={{width:'100%'}}>
                  <InputLabel htmlFor="currency">Type</InputLabel>
                  <Select
                    value={this.state.type}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'type',
                      id: 'type',
                    }}
                  >
                    <MenuItem value={'FREE'}>Free Trade</MenuItem>
                    <MenuItem value={'REST'}>Restricted</MenuItem>
                  </Select>
                </FormControl>
              <br />
              {(this.state.type === 'REST') &&
                <TextField
                  id="restricted_until"
                  name="restricted_until"
                  label="Restricted Until"
                  value={this.state.restricted_until}
                  type="date"
                  className={classes.textField}
                  onChange={this.handleChange}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  />
              }
              <br />
              {(this.state.companies) &&
                <FormControl className={classes.formControl} style={{width: '100%'}}>
                  <InputLabel htmlFor="currency">Instrument</InputLabel>
                  <Select
                    value={this.state.instrument}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'instrument',
                      id: 'instrument',
                    }}
                  >
                    {
                      this.state.companies.map((c,i) => {
                      return (
                        <MenuItem value={c._account}>{c._company_name} ({c._company_symbol})</MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              }
              {(this.state.instrument) &&
                <div>
                  Certificate Total: {utils.addThousandCommas(this.state.holdings['a' + this.state.instrument.toString()]._holdings)}<br/>
                  Units Available: {utils.addThousandCommas(this.state.remainder)}
                </div>
              }
                <br />
                <FormControl className={classes.formControl}>
                <TextField
                  id="quantity"
                  name="quantity"
                  label="Quantity"
                  className={classes.textField}
                  value={this.state.amount}
                  onChange={this.handleChange}
                  margin="normal"
                />
                </FormControl>
                <br />
                  <FormControl className={classes.formControl}>
                <TextField
                  id="comment"
                  name="comment"
                  label="Comment"
                  className={classes.textField}
                  value={this.state.comment}
                  onChange={this.handleChange}
                  margin="normal"
                />
                  </FormControl>
                <br />
                <Button variant="contained" color="secondary" onClick={this.complete}>
                    Complete
                </Button>
                &nbsp;
                <Button variant="outlined" color="secondary" onClick={this.close}>
                    Cancel
                </Button>
              </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps({auth})
{
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(WalletJournal))));
